import api from 'services/api';

/**
 * 예산차수 확정·확정취소 — BE BudgetRoundService 전용 API.
 * 확정 플래그는 /common/save 의 updateRound 로 바꾸지 않는다.
 */
export async function confirmBudgetRound(roundUid, { version, finalAdjNo } = {}) {
  const res = await api.post(`/bd/budget-round/${encodeURIComponent(roundUid)}/confirm`, {
    version,
    finalAdjNo,
  });
  return res.data || {};
}

export async function cancelConfirmBudgetRound(roundUid, { version } = {}) {
  const res = await api.post(`/bd/budget-round/${encodeURIComponent(roundUid)}/cancel-confirm`, {
    version,
  });
  return res.data || {};
}

/** 확정분 현액 재적재 — 해당 연도 편성확정·당해 행을 테넌트 모드(sumDelta/lastRound)로 다시 계산 */
export async function rebuildBudgetBalances(roundUid) {
  const res = await api.post(`/bd/budget-round/${encodeURIComponent(roundUid)}/rebuild-balance`, {});
  return res.data || {};
}
